import { useQuery } from '@tanstack/react-query';

import {
  getAllConversations,
  type GetAllConversationsResponse,
} from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import queryKeys from '@/queries/queryKeys';
import type { QueryOptions } from '@/types/react-query';

import type { Conversation, ConversationStatus } from '../../types';

export default function useConversations(
  partyId: string,
  filter?: {
    orderBy?: keyof Conversation;
    flowIds?: string[];
    sort?: 'asc' | 'desc';
    status?: ConversationStatus[];
  },
  options?: QueryOptions<GetAllConversationsResponse['items']>,
) {
  return useQuery({
    queryKey: queryKeys.conversations.list(filter),
    queryFn: async () => {
      const result = await getAllConversations(
        {
          query: {
            party_id: [partyId],
            flow_id: filter?.flowIds ?? [],
            order_by: filter?.orderBy ?? 'modified_at',
            sort: filter?.sort ?? 'desc',
            status: filter?.status ?? [],
          },
        },
        wgApi,
      );

      return result.items;
    },
    ...options,
  });
}
